const getInputPosition = input => {
  // Initialize
  const oField = input
  let iCaretPos = 0

  if (!oField) return iCaretPos

  // IE Support
  if (document.selection) {
    // Set focus on the element
    oField.focus()

    // To get cursor position, get empty selection range
    const oSel = document.selection.createRange()

    // Move selection start to 0 position
    oSel.moveStart('character', -oField.value.length)

    // The caret position is selection length
    iCaretPos = oSel.text.length
  } else if (oField.selectionStart || oField.selectionStart === '0') {
    iCaretPos = oField.selectionStart
  }

  return iCaretPos
}

export default getInputPosition



// WEBPACK FOOTER //
// ./src/common/lib/inputPosition.js